/** Smena boshlanishi va tugashi (xodimning o'z vaqtida) */
import { useTranslation } from "react-i18next";
import type { Me } from "@/features/auth/types";
import { TimeInput } from "@/components/ui/field";
import type { WidgetItem } from "../types";
import type { ShiftConfig } from "./index";

type Props = { item: WidgetItem<ShiftConfig>; me: Me; onChange: (config: ShiftConfig) => void };

export function ShiftSettings({ item, me, onChange }: Props) {
  const { t } = useTranslation("widgets");
  const c = item.config;
  return (
    <div className="space-y-3">
      <div className="grid grid-cols-2 gap-2">
        <label className="text-[12px] text-muted">
          {t("shift.start")}
          <TimeInput value={c.start} onChange={(e) => onChange({ ...c, start: e.target.value })} className="mt-1 w-full" />
        </label>
        <label className="text-[12px] text-muted">
          {t("shift.end")}
          <TimeInput value={c.end} onChange={(e) => onChange({ ...c, end: e.target.value })} className="mt-1 w-full" />
        </label>
      </div>
      <p className="text-[11px] text-muted">{t("shift.hint", { tz: me.timezone || "Asia/Tashkent" })}</p>
    </div>
  );
}
